import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=0a98a7bf&scoped=true&lang=pug"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"
import style0 from "./Textarea.styl?vue&type=style&index=0&id=0a98a7bf&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a98a7bf",
  null
  
)

export default component.exports